module.exports = __webpack_public_path__ + "static/media/pennysark.3e54c000.png";